"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHPersistentReference = void 0;
const KHReference_1 = require("./KHReference");
/**
 * Variable reference that saves values to json. If the value being saved is one
 * other than number, boolean, json, or string, an overridden class should be
 * added that supports serializing and deserializing.
 *
 * It will only persist if the options parameter is set.
 */
class KHPersistentReference extends KHReference_1.KHReference {
    constructor(defaultValue, saveOnChange = true) {
        super(defaultValue);
        this.saveOnChange = saveOnChange;
        this.defaultValue = defaultValue;
        this.value = this.defaultValue;
    }
    toJSON() {
        return this.value;
    }
    fromJSON(json) {
        let value = json;
        // Bypass this class's set to avoid a save loop.
        super.set(value);
    }
    setManager(manager) {
        this.manager = manager;
    }
    set(value) {
        super.set(value);
        if (this.saveOnChange) {
            this.save();
        }
    }
    /**
     * Triggers a save on its owning manager, if present. Useful if you're
     * altering the internals of a JSON object.
     */
    save() {
        var _a;
        (_a = this.manager) === null || _a === void 0 ? void 0 : _a.save(this);
    }
}
exports.KHPersistentReference = KHPersistentReference;
